import React from 'react';
export function OrigenSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-105">
      <div className="max-w-3xl mx-auto" data-id="element-106">
        <div className="bg-[#fafaf9] border-l-4 border-[#D90B10] rounded-r-2xl p-8 md:p-12 shadow-sm" data-id="element-107">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-108">
            Este mapa nació de una crisis mía.
          </h2>

          <div className="space-y-5 text-lg text-gray-800 leading-relaxed" data-id="element-109">
            <p data-id="element-110">
              Pasé 20 años vendiendo. Llegué a ser VP de multinacionales, fundé
              dos negocios, y en el camino viví lo mismo que hoy te puede estar
              pasando a ti:
            </p>

            <p data-id="element-111">
              Trabajar muchísimo, sentirme ocupada todo el día, y no entender
              por qué no crecía.
            </p>

            <p data-id="element-112">
              Hasta que una emergencia familiar me obligó a hacer en 5 horas lo
              que antes me llevaba 12. Ahí vi por primera vez lo que no había
              visto en 20 años: mis fugas.
            </p>

            <p data-id="element-113">
              Esta herramienta es el primer paso del método que uso hoy con
              empresarias y equipos comerciales en 15 países. Es gratis. Y es el
              punto de partida.
            </p>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200" data-id="element-114">
            <p className="text-base font-bold text-gray-900" data-id="element-115">
              — Carolina Gómez
            </p>
            <p className="text-sm italic text-gray-500 mt-1" data-id="element-116">
              Estratega en Ventas como Negocio
            </p>
          </div>
        </div>
      </div>
    </section>;
}